import React, { useState, memo } from 'react';
import CustomAutocomplete from '../Inputs/CustomAutocomplete';
import { useApi } from '../../hooks';
import { getUsersRequest } from '../../api/userApi';
import { getFullName } from '../../helpers/stringHelper';

export const UsersAutocomplete = memo(({
  id, label = 'Пользователь', sx, onChange, value, error, name = 'user_id',
}) => {
  const [users, setUsers] = useState([]);

  const { isLoading } = useApi({
    setter: (newUser) => {
      setUsers(newUser.map((user) => ({
        id: user.id,
        value: user.id,
        label: getFullName(user),
      })));
    },
    request: getUsersRequest,
  });

  return (
    <CustomAutocomplete
      label={label}
      id={id}
      sx={sx}
      loading={isLoading}
      error={error}
      name={name}
      options={users}
      value={value}
      onChange={onChange}
    />
  );
});
